module.exports = __webpack_public_path__ + "static/media/Shrimp.bb6a7362.svg";